// src/components/dashboard/AdminAssociationsTab.jsx
import React, { useState } from 'react';
import { associationService } from '../../services/api';

const initialState = { name: '', contact: '', description: '', active: true, logoUrl: '' };

export default function AdminAssociationsTab({ data: associations, setData: setAssociations, actionLoading, setActionLoading, setError }) {
    const [isFormVisible, setIsFormVisible] = useState(false);
    const [currentAssociation, setCurrentAssociation] = useState(initialState);

    const handleSave = async (e) => {
        e.preventDefault();
        if (actionLoading) return;
        setActionLoading(true);
        setError(null);

        try {
            let result;
            if (currentAssociation.id) {
                result = await associationService.updateAssociation(currentAssociation.id, currentAssociation);
                setAssociations(prev => prev.map(a => a.id === currentAssociation.id ? result.data || result : a));
            } else {
                result = await associationService.createAssociation(currentAssociation);
                setAssociations(prev => [...prev, result.data || result]);
            }
            setCurrentAssociation(initialState);
            setIsFormVisible(false);
        } catch (err) {
            setError('Error al guardar la Asociación.');
        } finally {
            setActionLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (actionLoading) return;
        if (!window.confirm('¿Confirmas la inactivación (eliminación) de esta Asociación?')) return;
        
        setActionLoading(true);
        setError(null);
        try {
            await associationService.deleteAssociation(id); 
            setAssociations(prev => prev.filter(a => a.id !== id));
        } catch (err) {
            setError('Error al inactivar la Asociación.');
        } finally {
            setActionLoading(false);
        }
    };

    const handleEdit = (item) => { setCurrentAssociation(item); setIsFormVisible(true); };
    const handleNew = () => { setCurrentAssociation(initialState); setIsFormVisible(true); };

    return (
        <div className="mt-4">
            <h4 className="text-lg font-semibold mb-3">Gestión de Asociaciones</h4>
            <button onClick={handleNew} className="mb-4 btn btn-green" disabled={actionLoading}>Crear Nueva Asociación</button>

            {isFormVisible && (
                <form onSubmit={handleSave} className="mb-6 p-4 border rounded bg-gray-50 space-y-3 max-w-lg">
                    <h5 className="font-bold">{currentAssociation.id ? 'Editar Asociación' : 'Nueva Asociación'}</h5>
                    
                    <input type="text" placeholder="Nombre" value={currentAssociation.name} onChange={(e) => setCurrentAssociation({ ...currentAssociation, name: e.target.value })} required className="input-field" disabled={actionLoading} />
                    <input type="text" placeholder="Contacto (Email/Teléfono)" value={currentAssociation.contact} onChange={(e) => setCurrentAssociation({ ...currentAssociation, contact: e.target.value })} className="input-field" disabled={actionLoading} />
                    <input type="text" placeholder="URL Logotipo (Opcional)" value={currentAssociation.logoUrl} onChange={(e) => setCurrentAssociation({ ...currentAssociation, logoUrl: e.target.value })} className="input-field" disabled={actionLoading} />
                    <textarea placeholder="Descripción" value={currentAssociation.description} onChange={(e) => setCurrentAssociation({ ...currentAssociation, description: e.target.value })} rows="3" className="input-field" disabled={actionLoading} />

                    <div className="flex space-x-2">
                        <button type="submit" className="btn btn-primary" disabled={actionLoading}>{actionLoading ? 'Guardando...' : 'Guardar Asociación'}</button>
                        <button type="button" onClick={() => setIsFormVisible(false)} className="btn btn-secondary" disabled={actionLoading}>Cerrar</button>
                    </div>
                </form>
            )}

            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="table-th">Nombre</th>
                            <th className="table-th">Contacto</th>
                            <th className="table-th">Acciones</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {associations.map((a) => (
                            <tr key={a.id}>
                                <td className="table-td">{a.name}</td>
                                <td className="table-td">{a.contact}</td>
                                <td className="table-td space-x-2">
                                    <button onClick={() => handleEdit(a)} className="text-[color:var(--primary)] hover:underline" disabled={actionLoading}>Editar</button>
                                    <button onClick={() => handleDelete(a.id)} className="text-red-600 hover:underline" disabled={actionLoading}>Eliminar</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}